import { Component, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';

/** Service file */
import { AssignProService } from '../assignPro.service';
import { CalendarService } from '../../../calendar/calendar.service';

/**Local component */
import { FuseConfirmDialogComponent } from '../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ToastComponent } from '../../../common/toast.component';

/**Local values */
import { assignPro, toastMsg, orders, spekwo } from '../../../utils/index';
import { CommonOrdersService } from '../../orders/commonOrders.service';

@Component({
    selector: 'pro-list',
    templateUrl: './proList.component.html',
    styleUrls: ['./proList.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class ProListComponent implements OnInit {

    toastMsg = toastMsg;
    currentOrderId: any;
    commonValues: any;
    orderValues = orders;
    spekwoValues = spekwo;
    allStatus: OrderStatus[];

    assignIsLoading: boolean = false;

    orderDetail = {
        acceptedBy : '',
        statusId:null,
    };
    StatusOrderDetail: any;


    dialogRef: any;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

    displayedColumns = ['photoUrl', 'name', 'email', 'phoneNumber', 'address', 'assignBtn'];
    proDataSource: MatTableDataSource<UserData>;
    proUsers: UserData[] = [];

    proUsersSubscription: Subscription;
    orderIdSubscription: Subscription;

    @ViewChild(MatPaginator) proPaginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        public dialog: MatDialog,
        private route: ActivatedRoute,

        /** Local component */
        public toastComponent: ToastComponent,

        /** Service file */
        public assignProService: AssignProService,
        public calendarService: CalendarService,
        public commonOrdersService: CommonOrdersService,
    ) {

        this.commonValues = assignPro;
    }
    ngOnInit() {
        this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
            this.allStatus = statusRes.length > 0 ? statusRes : [];
        });
        /** 
         * Get all pro users 
         * */
        this.proUsersSubscription =
            this.assignProService.onAllProUsers.subscribe(response => {
                this.assignIsLoading = true;
                if (!response.loading) {
                    this.proUsers = response.users;
                    this.proDataSource = new MatTableDataSource(this.proUsers);
                    this.proDataSource.paginator = this.proPaginator;
                    this.proDataSource.sort = this.sort;
                    this.assignIsLoading = false;
                }

            }, err => {
                this.assignIsLoading = false;
            })

        /** 
         *  get current order from params
        */
        this.route.params.subscribe(params => {
            this.currentOrderId = params.id;
        });



        /** 
        *  get current order schedule request details
       */
        this.orderIdSubscription =
            this.assignProService.orderStatus.subscribe(response => {
                if(response && response.details){

                    this.orderDetail.acceptedBy = response.details.acceptedBy;
                    this.orderDetail.statusId = response.details.statusId;
                }
            })

      

        

       

    }

    ngOnDestroy() {
        this.orderIdSubscription.unsubscribe();
    }
    /**
     * Set the paginator and sort after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    ngAfterViewInit() {
        // this.proDataSource.paginator = this.proPaginator;
        // this.proDataSource.sort = this.sort;
    }
    /**
     * Assign pro to job
     * @param user -Passing user object
     */
    assignMe(user) {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: true
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.jobConfirm;
        this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.jobHead;
        this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.jobOk;
        this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.jobCancel;

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {

                this.assignIsLoading = true;
                /**
                 * Once confirm, changed status
                 */
                this.assignProService.changeStatusOfOrder(this.currentOrderId, user.userId)
                    .then(response => {

                        this.toastComponent.showToast(this.toastMsg.jobAssigned);
                        this.assignProService.viewChanged.next('afterAssign');

                        /** Send mail */
                        this.calendarService.sendMail(this.currentOrderId, user.email)
                            .then((res: any) => {
                                this.toastComponent.showToast(res.status === "completed" ?
                                    this.toastMsg.mailSent : this.toastMsg.mailNotSent);
                            })
                        this.assignIsLoading = false;
                    })
                    .catch(err => {
                        console.log('changeStatusOfOrder', err);
                    })

            }
            this.confirmDialogRef = null;
        });
    }
    /**
     * Filter table
     * @param filterValue 
     */
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.proDataSource.filter = filterValue;
    }

    setDefaultPic(event) {
        event.target.src = this.spekwoValues.defaultImg;
    }
}


export interface UserData {
    photoUrl: string,
    name: string;
    email: string;
    phoneNumber: string;
    address: string
}

export interface OrderStatus {
    statusId: number;
    statusName: string;
    displayStatus: string;
  }
  


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/assignPro/pro-list/proList.component.ts